import { Component, OnInit } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { ActivatedRoute} from '@angular/router';
import { TotemService } from '../totem.service';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
@Component({
selector: 'app-evento-sel',
templateUrl: './evento-sel.component.html',
styleUrls: ['./evento-sel.component.css']
})
export class EventoSelComponent implements OnInit {
    listaeventos  = [];
    id;
    idtienda = '';
    haymapa = false;
    datosevento;
    planos: Array<any>;
    zoomactivo = true;
    rutaalt = false;
    rutaenviar = environment.tipoTransporte.pie;
    config: SwiperConfigInterface = {
      a11y: true,
      direction: 'horizontal',
      observer: true,
      spaceBetween: 10,
      slidesPerView: 1,
      loop: true,
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true
      };
    constructor(
        private totemService: TotemService,
        private route: ActivatedRoute,
        private location: Location
    ) { }

  async ngOnInit() {
    await this.totemService.getTotemConfig();

    // logica pra los planos
    this.planos = await this.totemService.getPlanos().toPromise();
    for (const plano of this.planos) {
      const numero = plano.piso_numero;
      if (numero > 0 ) {
      plano.nombre = 'N' + String(numero);
      } else {
        const piso = numero.toString()[1];
        plano.nombre = 'S' + piso;
      }
    }
    this.id = this.route.snapshot.paramMap.get('id');
    const eventoslist = await this.totemService.geteventos().subscribe(eventos => {
      // console.log('eventos',eventos);
      for (const even of eventos) {
        if (even.tipo_evento === 'Evento') {
          this.id = parseInt(this.id, 10);
          if (even.eve_id === this.id) {
            even.horaini = even.hora_inicio.substr(0, 5);
            even.horafin = even.hora_termino.substr(0, 5);
            let des = even.descripcion.replace('<p>', '');
            des = des.replace('</p>', '');
            this.datosevento = even;
            even.descripcionf = '<p>' + des + '</p>';
            if (this.datosevento.punto_interes !== 0) {
              this.haymapa = true;
              this.idtienda = this.datosevento.punto_interes;
            }
          }
          this.listaeventos.push(even);
          }
      }
      console.log('el ', this.datosevento, 'id', this.idtienda, 'hay ', this.haymapa);
    });
  }





    public goBack() {
      this.location.back();
    }
    hacerzoom() {
      this.cancelartimer();
      this.zoomactivo = !this.zoomactivo;
      console.log('zoom activo', this.zoomactivo);
    }
    public iconoruta() {
      if (this.rutaenviar === environment.tipoTransporte.pie) {
        this.rutaenviar = environment.tipoTransporte.alternativo;
      } else {
        this.rutaenviar = environment.tipoTransporte.pie;
      }
      console.log('cambio ruta', this.rutaenviar);
      this.cancelartimer();
      this.rutaalt = !this.rutaalt;
    }
    // logica de reinicio
  scrollevent = (event: any): void => {
    console.log('scroll');
    this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }
}
